// Paketler "Katalogdan ekle" ağacı: kategori kutusu alt ağacın EKLENEBİLİR yapraklarını seçer.
// Eklenebilir yaprak = kategori değil ∧ ortak katalog ∧ aktif ∧ pakette/taslakta yok (çağıran
// `isEligible` ile verir). Kullanımdan kalkmış / müşteriye özel / pakette olan yaprak asla toggle
// olmaz. Arama açıkken (`visible` ≠ null) yalnız görünen eklenebilir yapraklar sayılır.

import type { KpiMetric } from "@mahir/shared";
import { subtreeLeafIds, type IndicatorTree, type TriState } from "./kpi-set-editor";

export interface CategoryBoxState {
  state: TriState;
  /** eklenebilir yapraklardan seçili olanlar */
  picked: number;
  /** eklenebilir yaprak sayısı */
  eligible: number;
  /** alt ağaçta zaten pakette olan yaprak sayısı */
  inPackage: number;
}

export function eligibleLeafIds(
  tree: IndicatorTree<KpiMetric>,
  id: string,
  isEligible: (m: KpiMetric) => boolean,
  visible: ReadonlySet<string> | null,
): string[] {
  const out: string[] = [];
  for (const leaf of subtreeLeafIds(tree, id)) {
    if (visible && !visible.has(leaf)) continue;
    const node = tree.byId.get(leaf)?.node;
    if (node && isEligible(node)) out.push(leaf);
  }
  return out;
}

export function categoryBoxState(
  tree: IndicatorTree<KpiMetric>,
  id: string,
  selected: ReadonlySet<string>,
  inPackage: ReadonlySet<string>,
  isEligible: (m: KpiMetric) => boolean,
  visible: ReadonlySet<string> | null,
): CategoryBoxState {
  const ids = eligibleLeafIds(tree, id, isEligible, visible);
  const picked = ids.filter((l) => selected.has(l)).length;
  const pkg = subtreeLeafIds(tree, id).filter(
    (l) => (!visible || visible.has(l)) && inPackage.has(l),
  );
  const state: TriState =
    ids.length === 0 || picked === 0 ? "none" : picked === ids.length ? "all" : "some";
  return { state, picked, eligible: ids.length, inPackage: pkg.length };
}

/** Hepsi seçiliyse eklenebilirleri bırakır, değilse hepsini seçer; diğer seçimlere dokunmaz. */
export function toggleCategoryEligible(
  tree: IndicatorTree<KpiMetric>,
  id: string,
  selected: ReadonlySet<string>,
  isEligible: (m: KpiMetric) => boolean,
  visible: ReadonlySet<string> | null,
): Set<string> {
  const next = new Set(selected);
  const ids = eligibleLeafIds(tree, id, isEligible, visible);
  const all = ids.length > 0 && ids.every((l) => selected.has(l));
  for (const l of ids) {
    if (all) next.delete(l);
    else next.add(l);
  }
  return next;
}
